import { Route } from '@angular/router';
import { JobDetailsComponent } from './jobDetails.component';

export const JobDetailsRoutes: Route[] = [
  {
    path: 'doc',
    component: JobDetailsComponent
  },
  {
    path: 'doc/:id',
    component: JobDetailsComponent
  },



];
